import UserModel from './model.js'
import {
  ToogleAuthSessionProperties,
  RemoveUserSessionProperties} from './action.js'
export default {
  UserAuth:function(params){
      if(params.UserReducer.is_auth){
        return {"message":"You already Logged in"}
      }
      params.model = UserModel
      params.RunRedux(ToogleAuthSessionProperties(true))
      UserModel.AuthUser(params)
  },
  Logout: function(params){
    params.RunRedux(RemoveUserSessionProperties())
    params.onloggedout(params.history)
  },
  RefreshToken :function(params){
    params.refresh_token = params.UserReducer.refresh_token
    params.RunRedux(ToogleAuthSessionProperties(true))
    UserModel.RefreshToken(params)
  }
}



// WEBPACK FOOTER //
// ./src/App/user/presenter.js